<template>
  <a-modal :title="title" v-model="visible" @ok="handleOk" :width="460" :height="200" class="read-model1">
    <div class="read-content">
      <div class="hint-text">
        <span style="font-size:16px">{{content}}</span>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'readModel',
  data () {
    return {
      title: '温馨提示',
      visible: false,
      content: '您确认全部标记为已读吗？',
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    cancel () {
      this.visible = false
    },
    handleOk () {
      this.visible = false
      this.$emit('confirmRead')
    }
  }
}
</script>
<style lang="scss">
.read-model1 {
  .ant-modal-content {
    height: 220px;
    border-radius: 10px;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
    }
    .ant-modal-body {
      height: 60px !important;
      display: flex;
      justify-content: center;
      padding: 0;
    }
    .ant-btn {
      width: 140px;
      border-radius: 6px !important;
    }

    .read-content {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .hint-text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: 1.8;
      }
    }
  }
}
</style>
